var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplayWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0909 2H3.72727C2.22364 2 1 3.22364 1 4.72727V20C1 21.1046 1.89543 22 3 22H20.8182C21.9228 22 22.8182 21.1046 22.8182 20V4.72727C22.8182 3.22364 21.5945 2 20.0909 2ZM18.2727 16.5455C18.2727 17.0475 17.8657 17.4545 17.3636 17.4545H6.40909C5.90701 17.4545 5.5 17.0475 5.5 16.5455V16.5455C5.5 16.0434 5.90701 15.6364 6.40909 15.6364H17.3636C17.8657 15.6364 18.2727 16.0434 18.2727 16.5455V16.5455ZM18.2727 12C18.2727 12.5021 17.8657 12.9091 17.3636 12.9091H6.40909C5.90701 12.9091 5.5 12.5021 5.5 12V12C5.5 11.4979 5.90701 11.0909 6.40909 11.0909H17.3636C17.8657 11.0909 18.2727 11.4979 18.2727 12V12ZM18.2727 7.45455C18.2727 7.95662 17.8657 8.36364 17.3636 8.36364H6.40909C5.90701 8.36364 5.5 7.95662 5.5 7.45455V7.45455C5.5 6.95247 5.90701 6.54545 6.40909 6.54545H17.3636C17.8657 6.54545 18.2727 6.95247 18.2727 7.45455V7.45455Z",
    fill: "#034F81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayWall);
export default __webpack_public_path__ + "static/media/Display Wall.ac66425840844dd8ed03639fe6b0e149.svg";
export { ForwardRef as ReactComponent };